// Best-effort suppression of Mapbox client telemetry beacons.
//
// In development and offline previews `events.mapbox.com` cannot be reached
// (corporate DNS, firewall, China network conditions), and the SDK happily
// retries the beacon ~12 times per session — flooding DevTools with
// `ERR_NAME_NOT_RESOLVED` console noise and slowing the load.
//
// Mapbox GL JS exposes the legacy per-Map `setTelemetryEnabled(false)` toggle
// (deprecated but still honoured in v2 / v3). We call it via duck typing so
// we keep working when the API is renamed or removed in a future major.
import type { Map as MapboxMap } from 'mapbox-gl'

type TelemetryCapableMap = MapboxMap & {
  setTelemetryEnabled?: (enabled: boolean) => void
}

export function disableMapboxTelemetry(map: MapboxMap): void {
  try {
    ;(map as TelemetryCapableMap).setTelemetryEnabled?.(false)
  } catch {
    // SDK without the toggle — nothing to do.
  }
}
